import { ChatMessage, DataLoader, LoaderContext, MessageType } from '@chewy/chat-library-common';
import { useConversation } from '@chewy/chat-library-common';
import { useMemo } from 'react';
import { getRegistration } from '@chewy/chat-library-common/loaders/registry';
import { runLoaders } from '@chewy/chat-library-common/loaders/MessageOrchestrator';
import React from 'react';
import cn from 'classnames';
import styles from './StructuredMessage.module.scss';

interface StructuredMessageProps {
  message?: ChatMessage;
  ctx?: LoaderContext;
}

export default function StructuredMessage({ message, ctx }: StructuredMessageProps) {
  const { requestScroll } = useConversation();
  const isButtonOnly = useMemo(() => {
    if (!Array.isArray(message?.content)) {
      return false;
    }

    return message?.content.length > 0 && message.content.every(
      item => ['useraction', 'useractionwidget'].includes(item.widgetType.toLowerCase())
    );

  }, [message?.content]);

  const children = useMemo(() => {

    if (typeof message?.content === 'string' || !message?.content) {
      console.warn('StructuredMessage: Message does not contain WidgetContent: ', message?.content);
      return null;
    }

    return message.content.map((item, index) => {
      if (!item?.widgetType) {
        console.warn('StructuredMessage: item missing widgetType', item);
        return null;
      }

      const registration = getRegistration(item.widgetType);

      if (!registration?.component) {
        console.warn(`StructuredMessage: Bad registration: The results were: ${registration}`);
        console.warn(`StructuredMessage: No component registered for widget type: ${item?.widgetType}`);
        return null;
      }

      // Create a ChatMessage wrapper for the widget data
      const widgetMessage: ChatMessage = {
        ...message,
        type: item.widgetType as MessageType,
        content: [item]
      };

      // Create loader promise if dataLoader exists
      // Components can handle the promise internally to show loading states
      const loaderPromise = registration.dataLoader
        ? runLoaders(widgetMessage, [registration.dataLoader as unknown as DataLoader<ChatMessage, ChatMessage>], ctx)
        : undefined;

      // Skip animations for transcript messages
      const isFromTranscript = (message as any).source === 'TRANSCRIPT';
      const skipHeartAnimation = item.widgetType?.toLowerCase() === 'textheartanimation' && isFromTranscript;

      return React.createElement(registration.component as any, {
        key: `widget-${index}`,
        message: widgetMessage,
        data: item.widgets,
        payload: item.widgets,
        loaderPromise,
        trigger: skipHeartAnimation ? false : undefined,
        requestScroll,
      });
    }).filter(Boolean);
  }, [message, ctx, requestScroll]);

  return (
    <div
      className={cn(styles.structuredMessage, {
        [styles.structuredMessage_buttonOnly]: isButtonOnly,
        [styles.structuredMessage_user]: message?.responseType === 'user',
      })}
    >
      {children}
    </div>
  );
}
